<script setup lang="ts">
/**
 * ReloadPrompt - PWA-уведомление о доступности обновления.
 */
import { useRegisterSW } from 'virtual:pwa-register/vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW()

function close() {
  offlineReady.value = false
  needRefresh.value = false
}
</script>

<template>
  <Transition name="slide-up">
    <div
      v-if="offlineReady || needRefresh"
      class="fixed bottom-4 right-4 z-50 alert alert-info shadow-lg max-w-sm"
    >
      <div class="flex-1">
        <span
          v-if="offlineReady"
          class="text-sm"
        >{{ t('pwa.offlineReady') }}</span>
        <span
          v-else
          class="text-sm"
        >{{ t('pwa.newContent') }}</span>
      </div>
      <div class="flex gap-1">
        <button
          v-if="needRefresh"
          class="btn btn-sm btn-primary"
          @click="updateServiceWorker()"
        >
          {{ t('pwa.reload') }}
        </button>
        <button
          class="btn btn-sm btn-ghost"
          @click="close"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
